<article class="location-card">
  <div class="d-flex flex-column gap-3 gap-md-35">
    <div>
      <h1 [ngClass]="isBig() ? 'h4' : 'h5'">{{ location().name }}</h1>
      @if (location().geoLocation?.label) {
        <p class="mb-0 pre-line">
          {{ location().geoLocation?.label }}

          @if (location().geoLocation; as geo) {
            @if (geo.lat && geo.lng) {
              <a
                [href]="'https://www.google.com/maps?q=' + geo.lat + ',' + geo.lng"
                target="_blank"
                rel="noopener noreferrer"
                class="button button-icon button--xxs button--primary-subtle ms-1"
              >
                <fstr-icon [anchor]="'line-icon-map'"></fstr-icon>
              </a>
            }
          }

          <!-- {{ location().geoLocation | json }} -->
        </p>
      }
    </div>

    @if (location().text) {
      <div
        class="markdown-content location-text"
        fstrDynamicContent
        [innerHTML]="location().text! | resizeHtmlImages | stripEmbed: undefined | safe"
      ></div>
    }

    @if (location().departments.length) {
      <section>
        <h2 class="h6 mb-3 fs-body-sm">Openingstijden</h2>

        <mat-accordion>
          @for (department of location().departments; track department; let i = $index) {
            @if (!department.hideOpeningTimes) {
              <mat-expansion-panel
                (opened)="openPanel = i"
                (closed)="openPanel === i ? (openPanel = null) : null"
                [ngClass]="{
                  'mat-before-expanded': openPanel !== null && openPanel - 1 === i,
                  'mat-after-expanded': openPanel !== null && openPanel + 1 === i,
                }"
              >
                <mat-expansion-panel-header>
                  <mat-panel-title>{{ department.name }}</mat-panel-title>
                </mat-expansion-panel-header>
                <ul class="time-table">
                  @for (openingTime of department.openingTimes; track openingTime) {
                    <li class="time-table__item">
                      <span class="d-inline-block w-50">{{ dayOfWeekToDate(openingTime.day) | date: 'EEEE' }}</span>
                      <span class="d-inline-block w-50">{{ openingTime.openingTimes }}</span>
                    </li>
                  }
                </ul>
              </mat-expansion-panel>
            }
          }
        </mat-accordion>
      </section>
    }
  </div>
</article>
